
export const reviewSchema = {
  paymentModalData:{
    heading: "Time for a quick detour.",
    body: "We're taking you to Stripe, our third-party payment provider.",
  },
};

export default reviewSchema;